/* eslint-disable import/no-named-as-default */
import AnnotatedImage from './AnnotatedImage';

export default AnnotatedImage;
